<div>
  <div class="authGridContainer authGridContainer--login authGridContainer--fullScreen">
    <a class="authGrid__logo" href="/" aria-label="Link to main page" tabindex="0">
      <img src="./assets/sbk1-logo.svg" alt="SmartHCAAP" />
    </a>
    <div class="authGridColumn authGridColumn--callToActionParent">
      <div class="createFreeAccount">&nbsp;</div>
    </div>
    <div class="authGridColumn authGridColumn--formParent">
      <div class="formContainer loginForm">
        <h2>Kennwort ändern</h2>
        
        <!-- Email Verification Section (only for non-admins) -->
        <div *ngIf="!isAdmin && !emailVerified" class="email-verification-section" style="margin-bottom: 30px;">
          <h3 style="font-size: 18px; margin-bottom: 15px;">E-Mail-Verifizierung</h3>
          <p style="margin-bottom: 10px;">Ihre E-Mail-Adresse: <strong>{{ userEmail }}</strong></p>
          
          <button 
            mat-button 
            color="primary" 
            (click)="sendVerificationCode()" 
            [disabled]="isSendingCode"
            style="margin-bottom: 15px;">
            <span *ngIf="!isSendingCode">Code erneut senden</span>
            <span *ngIf="isSendingCode">Wird gesendet...</span>
          </button>
          
          <p class="notice" style="background-color: #e3f2fd; padding: 12px; border-radius: 4px; margin-bottom: 20px; font-size: 14px;">
            Wir haben Ihnen einen 6-stelligen Code an <strong>{{ userEmail }}</strong> gesendet.
          </p>
          
          <!-- OTP Input - 6 boxes -->
          <div class="otp-container" style="display: flex; justify-content: center; gap: 10px; margin: 20px 0;">
            <input
              #codeInput0
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              [(ngModel)]="verificationCode[0]"
              (input)="onCodeInput(0, $event)"
              (keydown)="onCodeKeyDown(0, $event)"
              class="otp-input"
              style="width: 50px; height: 60px; text-align: center; font-size: 24px; font-weight: bold; border: 2px solid #ddd; border-radius: 8px; outline: none;"
              [style.border-color]="verificationCode[0] ? '#003771' : '#ddd'"
            />
            <input
              #codeInput1
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              [(ngModel)]="verificationCode[1]"
              (input)="onCodeInput(1, $event)"
              (keydown)="onCodeKeyDown(1, $event)"
              class="otp-input"
              style="width: 50px; height: 60px; text-align: center; font-size: 24px; font-weight: bold; border: 2px solid #ddd; border-radius: 8px; outline: none;"
              [style.border-color]="verificationCode[1] ? '#003771' : '#ddd'"
            />
            <input
              #codeInput2
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              [(ngModel)]="verificationCode[2]"
              (input)="onCodeInput(2, $event)"
              (keydown)="onCodeKeyDown(2, $event)"
              class="otp-input"
              style="width: 50px; height: 60px; text-align: center; font-size: 24px; font-weight: bold; border: 2px solid #ddd; border-radius: 8px; outline: none;"
              [style.border-color]="verificationCode[2] ? '#003771' : '#ddd'"
            />
            <input
              #codeInput3
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              [(ngModel)]="verificationCode[3]"
              (input)="onCodeInput(3, $event)"
              (keydown)="onCodeKeyDown(3, $event)"
              class="otp-input"
              style="width: 50px; height: 60px; text-align: center; font-size: 24px; font-weight: bold; border: 2px solid #ddd; border-radius: 8px; outline: none;"
              [style.border-color]="verificationCode[3] ? '#003771' : '#ddd'"
            />
            <input
              #codeInput4
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              [(ngModel)]="verificationCode[4]"
              (input)="onCodeInput(4, $event)"
              (keydown)="onCodeKeyDown(4, $event)"
              class="otp-input"
              style="width: 50px; height: 60px; text-align: center; font-size: 24px; font-weight: bold; border: 2px solid #ddd; border-radius: 8px; outline: none;"
              [style.border-color]="verificationCode[4] ? '#003771' : '#ddd'"
            />
            <input
              #codeInput5
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              [(ngModel)]="verificationCode[5]"
              (input)="onCodeInput(5, $event)"
              (keydown)="onCodeKeyDown(5, $event)"
              class="otp-input"
              style="width: 50px; height: 60px; text-align: center; font-size: 24px; font-weight: bold; border: 2px solid #ddd; border-radius: 8px; outline: none;"
              [style.border-color]="verificationCode[5] ? '#003771' : '#ddd'"
            />
          </div>
          
          <button
            mat-raised-button
            color="primary"
            (click)="verifyCode()"
            [disabled]="!isCodeComplete() || isVerifying"
            style="width: 100%; margin-top: 10px;">
            <span *ngIf="!isVerifying">Verifizieren</span>
            <span *ngIf="isVerifying">Wird verifiziert...</span>
          </button>
          
          <p *ngIf="verificationError" class="error" style="color: #d32f2f; margin-top: 10px; font-size: 14px;">
            {{ verificationError }}
          </p>
          
          <p *ngIf="verificationError && attemptsRemaining !== undefined" 
             [style.color]="attemptsRemaining === 0 ? '#d32f2f' : '#666'" 
             style="margin-top: 5px; font-size: 12px;">
            <span *ngIf="attemptsRemaining > 0">Verbleibende Versuche: {{ attemptsRemaining }}</span>
            <span *ngIf="attemptsRemaining === 0" style="font-weight: bold;">Keine Versuche mehr verbleibend. Bitte fordern Sie einen neuen Code an.</span>
          </p>
        </div>

        <!-- Password Change Form (shown after verification or for admins) -->
        <div *ngIf="isAdmin || emailVerified" class="password-change-section">
          <p class="text-gray-600 mb-4">Sie müssen Ihr Kennwort ändern, bevor Sie fortfahren können.</p>

          <form (ngSubmit)="changePassword()" [formGroup]="loginForm" novalidate>
            <div class="login-error" [hidden]="!error || isLoading">Fehler beim Ändern des Kennworts.</div>
            <br />

            <div class="login-fields" fxLayout="column">
              <mat-form-field [hideRequiredMarker]="true">
                <input type="password" matInput formControlName="password" [placeholder]="'Neues Kennwort'" required />
                <mat-error *ngIf="loginForm.controls['password'].invalid && loginForm.controls['password'].touched">
                  <span>Kennwort muss mindestens 6 Zeichen lang sein</span>
                </mat-error>
              </mat-form-field>
              <mat-form-field [hideRequiredMarker]="true">
                <input
                  type="password"
                  matInput
                  formControlName="pwdconfirm"
                  [placeholder]="'Kennwort bestätigen'"
                  required />
                <mat-error *ngIf="loginForm.controls['pwdconfirm'].invalid && loginForm.controls['pwdconfirm'].touched">
                  <span>Kennwort muss mindestens 6 Zeichen lang sein</span>
                </mat-error>
              </mat-form-field>
              <br />
              <button
                class="btnLogin"
                mat-focus-indicator
                mat-raised-button
                color="primary"
                type="submit"
                [disabled]="loginForm.invalid || isLoading">
                <span *ngIf="!isLoading">Kennwort ändern</span>
                <span *ngIf="isLoading">Wird gespeichert...</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
